import React from 'react';

export default function DokumenFinal() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Dokumen Final</h1>
      <p className="text-gray-500">Halaman Dokumen Final</p>
    </div>
  );
}
